// extracted by mini-css-extract-plugin
module.exports = {"card":"CardSkill_card__qkDpp"};